import { createFileRoute } from "@tanstack/react-router";
import ProlivRx from "@/pages/ProlivRx";
export const Route = createFileRoute("/prolivrx")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Proliv®Rx At-Home TMS Device | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Proliv Rx is a digital therapeutic for depression. Learn how it works and whether it complements TMS and SAINT TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Proliv®Rx At-Home TMS Device | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Proliv Rx is a digital therapeutic for depression. Learn how it works and whether it complements TMS and SAINT TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/prolivrx",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/prolivrx",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ProlivRx />;
}
